<div style="box-shadow: 0px 4px 28px 0px rgba(0, 47, 56, 0.05)" [classList]="'bg-white p-5 rounded-2xl ' + classesList">
  <ng-content></ng-content>
</div>
